export enum RichtextWidth {
  FULL = 'full',
  LARGE = 'large',
  MEDIUM = 'medium',
}

export enum HighlightBoxClassText {
  BASE = 'box-grey-base',
  DARK = 'box-grey-dark',
  MEDIUM = 'box-grey-md',
  LIGHT = 'box-grey-light',
}
